export default __webpack_public_path__ + "static/media/bronze.a15902f9.png";